import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** Usage: provide a descriptive label and either an Ionicon name or image source. */
@Component({
  selector: 'app-icon-button',
  templateUrl: './app-icon-button.component.html',
  styleUrls: ['./app-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppIconButtonComponent {
  @Input() icon = '';
  @Input() iconSrc = '';
  @Input() ariaLabel = '';
  @Input() showTooltip = true;
  @Input() color = 'medium';
  @Input() size: 'sm' | 'md' = 'md';
  @Input() disabled = false;
  @Input() loading = false;
  @Output() clicked = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }
}
